























































































import { defineComponent, reactive, toRefs, watch } from "@vue/composition-api";
import {
  getIntegrationSonarToken,
  updateIntegrationSonarToken,
  deleteIntegrationSonarToken
} from "@/api";
import { BadRequestError } from "@/api/types";
import { getErrorMessages } from "@/helpers/api-helper";
import Layout from "@/components/Atoms/Layout/index.vue";
import SettingBreadcrumbs from "@/components/Pages/Accounts/Molecules/SettingBreadcrumbs/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import GuideBar from "@/components/Atoms/GuideBar/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import { useRequest } from "@/helpers/hooks/useRequest";
import UniversityCard from "../../Molecules/UniversityCard/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import SuccessMessages from "../../Molecules/SuccessMessages/index.vue";

interface Data {
  updateSonarToken: string;
  successMessages: string[];
  errorMessages: string[];
}

export default defineComponent({
  name: "accountsFollowUniversities",
  components: {
    Layout,
    SettingBreadcrumbs,
    Heading,
    TextField,
    Button,
    GuideBar,
    ButtonConfig,
    LoadingView,
    UniversityCard,
    SuccessMessages
  },
  setup() {
    const [
      { data: sonarToken, loading: getSonarTokenLoading },
      runGetSonarToken
    ] = useRequest(() => getIntegrationSonarToken(), {
      immediate: true
    });

    const [
      { error: updateError, loading: updateSonarTokenLoading },
      runUpdateSonarToken
    ] = useRequest(() =>
      updateIntegrationSonarToken({
        sonar_token: state.updateSonarToken
      })
    );

    const [
      { error: deleteError, loading: deleteSonarTokenLoading },
      runDeleteSonarToken
    ] = useRequest(() => deleteIntegrationSonarToken());

    const state = reactive<Data>({
      updateSonarToken: sonarToken.value ? sonarToken.value.sonar_token : "",
      successMessages: [],
      errorMessages: []
    });

    // APIからSONARトークンを取得次第、初期値を設定
    watch(sonarToken, () => {
      state.updateSonarToken = sonarToken.value
        ? sonarToken.value.sonar_token
        : "";
    });

    const handleChangeSonarToken = (sonarToken: string) => {
      state.updateSonarToken = sonarToken;
    };

    const handleClickUpdate = async () => {
      state.errorMessages = [];
      await runUpdateSonarToken();
      if (!updateError.value) {
        state.successMessages = ["SONAR連携を登録しました。"];
      } else if (updateError.value instanceof BadRequestError) {
        state.errorMessages = getErrorMessages(updateError.value);
      }
    };

    const handleClickDelete = async () => {
      state.errorMessages = [];
      await runDeleteSonarToken();
      if (!deleteError.value) {
        state.successMessages = ["SONAR連携を解除しました。"];
        runGetSonarToken();
      } else if (deleteError.value instanceof BadRequestError) {
        state.errorMessages = getErrorMessages(deleteError.value);
      }
    };

    return {
      ...toRefs(state),
      sonarToken,
      getSonarTokenLoading,
      updateSonarTokenLoading,
      deleteSonarTokenLoading,
      handleChangeSonarToken,
      handleClickUpdate,
      handleClickDelete
    };
  }
});
